import { createFileRoute } from '@tanstack/react-router';
import { LocationDetailPage } from '@/features/inventory/LocationDetailPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/locations_/$locationId')({
  component: Page,
});
function Page() {
  const { locationId } = Route.useParams();
  return <LocationDetailPage key={locationId} locationId={locationId} />;
}
